<template>
  <v-card flat>
    <v-card-title class="map-title">Location</v-card-title>
    <v-card-subtitle class="map-subtitle"
      >{{ address.addressName }} | {{ address.postcode }} |
      {{ address.city }}</v-card-subtitle
    >
    <v-card-text>
      <div id="map" class="map-bx">Google map rendering...</div>
    </v-card-text>
  </v-card>
</template>

<script>
import { MapService } from "@/services";

export default {
  name: "DoctorMap",
  props: {
    address: Object
  },
  mounted() {
    setTimeout(() => {
      this.showDoctorOnMap();
    }, 1000);
  },
  methods: {
    showDoctorOnMap() {
      if (
        this.address &&
        this.address.location &&
        this.address.location.coordinates
      ) {
        const myLatLng = this.getLatLng(this.address.location.coordinates);
        const map = MapService.getMap({
          center: myLatLng,
          zoom: 14
        });
        MapService.getMarker({
          position: myLatLng,
          map: map,
          title: this.address.addressName
        });
      }
    }
  }
};
</script>

<style scoped>
#map {
  height: 400px;
}
.map-bx {
  border: 1px solid #e0e0e0;
}
.map-title {
  font-family: "Now Alt";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #27445b !important;
}
.map-subtitle {
  font-family: "Now Alt";
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  color: #27445b !important;
}
</style>
